import ObjectiveFields from "@components/notes/legacy/LegacyObjectiveFields";
import { useFormContext, useWatch } from "react-hook-form";

import { NoteInput } from "./LegacyNoteInput";

export function ObjectiveFormSection({
  isEditFieldModeActive,
  getValues,
  onMouseUp,
  noteUuid,
  aiAssistantEnabled,
  languageAiAssistantEnabled,
  subheadingsAiAssistantEnabled,
}) {
  const { control, setValue, resetField } = useFormContext();
  const shouldUseGenericObjective = useWatch({
    control,
    name: "shouldUseGenericObjective",
  });

  return (
    <>
      {shouldUseGenericObjective ? (
        <NoteInput
          control={control}
          title={"Objective"}
          fieldName="objective"
          getValues={getValues}
          onMouseUp={onMouseUp}
          name="objective"
          headerStyle="bg-pink-400 dark:bg-pink-600"
          boxStyle="border-pink-300 bg-pink-50 dark:bg-pink-700/20 dark:border-pink-600 divide-pink-300 dark:divide-pink-600"
          noteUuid={noteUuid}
          aiAssistantEnabled={aiAssistantEnabled}
          languageAiAssistantEnabled={languageAiAssistantEnabled}
          subheadingsAiAssistantEnabled={
            subheadingsAiAssistantEnabled
          }
        />
      ) : (
        <div className="border border-pink-300 bg-pink-50 dark:bg-gray-700 dark:border-pink-600 p-4 mt-4 mb-6 rounded-xl w-full text-sm align-top text-gray-700 dark:text-gray-300">
          <div className="absolute z-10 top-6 left-0 rounded-tr-full rounded-tl-full rounded-br-full bg-pink-400 dark:bg-pink-600 py-1 px-4">
            <h4 className="text-white dark:text-gray-300">
              Objective
            </h4>
          </div>
          <ObjectiveFields
            control={control}
            setValue={setValue}
            getValues={getValues}
            isEditFieldModeActive={isEditFieldModeActive}
            resetField={resetField}
          />
        </div>
      )}
    </>
  );
}
